module.exports = __webpack_public_path__ + "img/20_84.975293bc.png";